import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-px-loader',
  templateUrl: './px-loader.component.html',
  styleUrls: ['./px-loader.component.scss']
})
export class PxLoaderComponent implements OnInit {

  @Input() inlineLoader?: boolean =  false;

  constructor() { }

  ngOnInit() {
  }

}
